(function () {
  function fmt(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }

  function setupLightbox(lb) {
    var img = lb.querySelector('[data-lb=img]');
    var count = lb.querySelector('[data-lb=count]');
    var prev = lb.querySelector('[data-lb=prev]');
    var next = lb.querySelector('[data-lb=next]');
    var close = lb.querySelector('[data-lb=close]');
    var list = [], idx = 0, opener = null, startX = null;
    function show() {
      img.src = list[idx];
      var many = list.length > 1;
      prev.hidden = !many; next.hidden = !many; count.hidden = !many;
      count.textContent = (idx + 1) + ' / ' + list.length;
    }
    function go(s) { if (list.length < 2) return; idx = (idx + s + list.length) % list.length; show(); }
    function hide() { lb.hidden = true; document.documentElement.style.overflow = ''; if (opener) opener.focus(); }
    lb.addEventListener('click', function (e) {
      if (e.target === lb) { hide(); return; }
      var b = e.target.closest('[data-lb]'); if (!b) return;
      var a = b.getAttribute('data-lb');
      if (a === 'close') hide(); else if (a === 'prev') go(-1); else if (a === 'next') go(1);
    });
    lb.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX; startX = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') hide(); else if (e.key === 'ArrowLeft') go(-1); else if (e.key === 'ArrowRight') go(1);
    });
    return function (urls, from) {
      list = urls.filter(Boolean); if (!list.length) return;
      idx = 0; opener = from || null; show();
      lb.hidden = false; document.documentElement.style.overflow = 'hidden'; close.focus();
    };
  }

  function init(root) {
    if (root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '');
    var lbEl = root.querySelector('[data-role=lb]');
    var openLightbox = function () {};
    if (lbEl) { document.body.appendChild(lbEl); openLightbox = setupLightbox(lbEl); }

    var min = parseInt(root.dataset.min, 10) || 2;
    var disc = parseInt(root.dataset.disc, 10) || 0;
    var discText = root.dataset.discText || fmt(disc);
    var cartUrl = root.dataset.cartUrl || '/cart';
    var addUrl = (root.dataset.addUrl || '/cart/add') + '.js';
    var KEY = 'gracia-regalo-v1';
    var BOXKEY = 'gracia-regalo-estuche-v1';
    var cards = {};
    var byHandle = {};
    root.querySelectorAll('.rg-card').forEach(function (c) { cards[c.dataset.variant] = c; byHandle[c.dataset.handle] = c.dataset.variant; });
    function q(r) { return root.querySelector('[data-role=' + r + ']'); }
    var els = { msg: q('msg'), fill: q('fill'), slots: q('slots'), was: q('was'), total: q('total'), save: q('save'), add: q('add'), toast: q('toast'), toastText: q('toast-text'), box: q('box'), boxQty: q('box-qty') };
    var boxId = els.box ? els.box.dataset.variant : null;
    var boxPrice = els.box ? (parseInt(els.box.dataset.price, 10) || 0) : 0;
    var box = 0;
    var picks = [];
    var busy = false;
    var toastTimer = null;

    function qtyOf(id) { var c = 0; picks.forEach(function (p) { if (p === id) c++; }); return c; }
    function maxOf(id) { return parseInt(cards[id].dataset.max, 10) || 0; }
    function maxBox() { return boxId ? Math.max(0, picks.length - 1) : 0; }
    function toast(t) {
      els.toastText.textContent = t; els.toast.hidden = false;
      clearTimeout(toastTimer); toastTimer = setTimeout(function () { els.toast.hidden = true; }, 3000);
    }
    function save() {
      try { sessionStorage.setItem(KEY, JSON.stringify(picks)); sessionStorage.setItem(BOXKEY, String(box)); } catch (e) {}
    }

    function add(id) {
      if (!cards[id]) return;
      if (qtyOf(id) >= maxOf(id)) { toast('No nos quedan más de esta pieza'); return; }
      picks.push(id);
      if (picks.length === min) toast('🎁 ¡Listo! Tu regalo tiene ' + discText + ' menos y envío gratis');
      render();
    }
    function removeAt(i) { if (i > -1 && i < picks.length) { picks.splice(i, 1); render(); } }

    function render() {
      Object.keys(cards).forEach(function (id) {
        var c = cards[id]; var n = qtyOf(id);
        var dec = c.querySelector('[data-act=dec]');
        var inc = c.querySelector('[data-act=inc]');
        var qty = c.querySelector('[data-role=qty]');
        dec.hidden = n === 0; qty.hidden = n === 0; qty.textContent = n;
        inc.textContent = n === 0 ? 'Agregar al regalo' : '+';
        inc.classList.toggle('is-compact', n > 0);
        inc.disabled = n >= maxOf(id);
        c.classList.toggle('is-picked', n > 0);
        var badge = c.querySelector('[data-role=count]');
        badge.hidden = n === 0; badge.textContent = '×' + n;
      });

      var count = picks.length;
      var slotCount = Math.max(min, count);
      els.slots.textContent = '';
      for (var i = 0; i < slotCount; i++) {
        var id = picks[i]; var slot;
        if (id) {
          var c = cards[id];
          slot = document.createElement('button'); slot.type = 'button';
          slot.className = 'rg-slot is-filled'; slot.setAttribute('data-index', i);
          slot.setAttribute('aria-label', 'Quitar ' + c.dataset.title);
          var im = document.createElement('img'); im.src = c.dataset.img; im.alt = '';
          var x = document.createElement('span'); x.className = 'rg-slot__x'; x.setAttribute('aria-hidden', 'true'); x.textContent = '×';
          slot.appendChild(im); slot.appendChild(x);
        } else {
          slot = document.createElement('span'); slot.className = 'rg-slot'; slot.textContent = i + 1;
        }
        els.slots.appendChild(slot);
      }
      if (count >= min) {
        var more = document.createElement('span'); more.className = 'rg-slot rg-slot--more'; more.setAttribute('aria-hidden', 'true'); more.textContent = '+';
        els.slots.appendChild(more);
      }

      if (els.box) {
        var mb = maxBox();
        if (box > mb) box = mb;
        els.box.hidden = count < 2;
        els.boxQty.textContent = box;
        els.box.querySelector('[data-act=box-dec]').disabled = box === 0;
        els.box.querySelector('[data-act=box-inc]').disabled = box >= mb;
        els.box.classList.toggle('is-on', box > 0);
      }

      var regular = 0;
      picks.forEach(function (p) { regular += parseInt(cards[p].dataset.price, 10) || 0; });
      regular += box * boxPrice;
      var d = count >= min ? disc : 0;
      var total = regular - d;
      els.total.textContent = fmt(total);
      els.was.hidden = d === 0; els.was.textContent = fmt(regular);
      els.save.hidden = d === 0; els.save.textContent = 'Ahorras ' + discText + ' + envío gratis';

      var msg;
      if (count === 0) msg = 'Elige ' + min + ' o más piezas: ' + discText + ' menos y envío gratis.';
      else if (count < min) { var left = min - count; msg = 'Agrega ' + (left === 1 ? '1 pieza más' : left + ' piezas más') + ' y tu regalo tiene ' + discText + ' menos y envío gratis 🎁'; }
      else if (count === min) msg = '🎁 ¡Tu regalo tiene ' + discText + ' menos y envío gratis! Puedes sumar más piezas.';
      else msg = '🎁 ' + count + ' piezas · ' + discText + ' menos y envío gratis.';
      els.msg.textContent = msg;
      els.fill.style.width = Math.min(100, Math.round(count / min * 100)) + '%';
      root.classList.toggle('is-complete', count >= min);

      if (!busy) {
        els.add.disabled = count === 0;
        els.add.textContent = count === 0 ? 'Elige tus piezas' : (count >= min ? 'Agregar regalo al carrito · ' : 'Agregar al carrito · ') + fmt(total);
      }
      save();
    }

    function submit() {
      if (busy || !picks.length) return;
      busy = true; els.add.disabled = true; els.add.textContent = 'Agregando…';
      var map = {}, order = [];
      picks.forEach(function (id) { if (!map[id]) { map[id] = 0; order.push(id); } map[id]++; });
      var items = order.map(function (id) { return { id: parseInt(id, 10), quantity: map[id] }; });
      if (boxId && box > 0) items.push({ id: parseInt(boxId, 10), quantity: box });
      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (data) { if (!res.ok) throw data; return data; }); })
        .then(function () { try { sessionStorage.removeItem(KEY); sessionStorage.removeItem(BOXKEY); } catch (e) {} window.location.href = cartUrl; })
        .catch(function (err) { busy = false; toast((err && err.description) || 'No pudimos agregar tu regalo. Intenta de nuevo.'); render(); });
    }

    root.addEventListener('click', function (e) {
      var t = e.target.closest('button'); if (!t || !root.contains(t)) return;
      var act = t.getAttribute('data-act');
      if (act === 'zoom') { openLightbox((t.getAttribute('data-gallery') || '').split('|'), t); return; }
      if (act === 'inc') { add(t.closest('.rg-card').dataset.variant); return; }
      if (act === 'dec') { removeAt(picks.lastIndexOf(t.closest('.rg-card').dataset.variant)); return; }
      if (act === 'box-inc') { if (box < maxBox()) { box++; render(); } return; }
      if (act === 'box-dec') { if (box > 0) { box--; render(); } return; }
      if (t.classList.contains('rg-slot')) { removeAt(parseInt(t.getAttribute('data-index'), 10)); return; }
      if (t.getAttribute('data-role') === 'add') submit();
    });

    var fromUrl = new URLSearchParams(window.location.search).get('items');
    if (fromUrl) {
      fromUrl.split(',').forEach(function (h) { var id = byHandle[h.trim()]; if (id && qtyOf(id) < maxOf(id)) picks.push(id); });
    } else {
      try {
        (JSON.parse(sessionStorage.getItem(KEY) || '[]') || []).forEach(function (id) { id = String(id); if (cards[id] && qtyOf(id) < maxOf(id)) picks.push(id); });
        box = parseInt(sessionStorage.getItem(BOXKEY) || '0', 10) || 0;
      } catch (e) {}
    }
    render();
  }

  function boot() { document.querySelectorAll('[data-regalo]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();